import React, { forwardRef } from 'react';

import mapModifiers from 'utils/functions';

interface SectionProps {
  id?: string;
  children?: React.ReactNode;
  className?: string;
  noPaddingTop?: boolean;
  noPaddingBottom?: boolean;
}

const Section = forwardRef<HTMLDivElement, SectionProps>(
  (
    {
      id,
      children,
      className,
      noPaddingTop,
      noPaddingBottom,
    },
    ref,
  ) => (
    <section
      id={id}
      ref={ref}
      className={`
        ${mapModifiers('o-section',
        noPaddingTop && 'noPaddingTop',
        noPaddingBottom && 'noPaddingBottom')}
        ${className}`}
    >
      {children}
    </section>
  ),
);

Section.defaultProps = {
  id: undefined,
  children: undefined,
  className: '',
  noPaddingTop: false,
  noPaddingBottom: false,
};

export default Section;
